if (!customElements.get('menu-bracket')) {
  class MenuBracket extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector(':scope > ul');
      if (!this.list) return;

      this.items = Array.from(this.list.querySelectorAll(':scope > li > .header__menu-item'));
      if (!this.items.length) return;

      this.bracket = new BracketIndicator({
        container: this.list,
        items: this.items,
        className: 'header__menu-bracket',
        getRestingItem: () => this.currentPageItem(),
        fillContainerWhenEmpty: true,
      });
    }

    disconnectedCallback() {
      if (this.bracket) this.bracket.destroy();
    }

    currentPageItem() {
      return this.list.querySelector(':scope > li > .header__menu-item[aria-current="page"]') || null;
    }
  }

  customElements.define('menu-bracket', MenuBracket);
}
